// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#SplashAnimation__wrp {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #030303;
  overflow: hidden;
  z-index: 800;
}
#SplashAnimation__wrp .netflixintro {
  display: block;
  position: relative;
  width: 300px;
  height: 300px;
  overflow: hidden;
  animation-name: zoom-in;
  animation-delay: 0.5s;
  animation-duration: 3.5s;
  animation-timing-function: ease-in;
  animation-fill-mode: forwards;
  background-size: 4000px;
  background-position: -1950px 0;
}
#SplashAnimation__wrp .netflixintro::before {
  content: "";
  position: absolute;
  display: block;
  background-color: #030303;
  width: 150%;
  height: 30%;
  left: -25%;
  bottom: -27%;
  border-radius: 50%;
  z-index: 5;
  transform-origin: left center;
  background-size: 4000px;
  background-position: -1950px 0;
}
#SplashAnimation__wrp .netflixintro[data-letter=F] {
  transform-origin: 30% center;
}
#SplashAnimation__wrp .netflixintro[data-letter=F] .helper-1 {
  width: 19.5%;
  height: 100%;
  background-color: rgba(228, 9, 19, 0.5);
  left: 22%;
  top: 0;
  transform: rotate(180deg);
  animation-name: fading-lumieres-box;
  animation-duration: 2s;
  animation-delay: 0.6s;
  animation-fill-mode: forwards;
}
#SplashAnimation__wrp .netflixintro[data-letter=F] .helper-1 .effect-brush {
  animation-name: brush-moving;
  animation-duration: 2.5s;
  animation-fill-mode: forwards;
  animation-delay: 1.2s;
}
#SplashAnimation__wrp .netflixintro[data-letter=F] .helper-1 .effect-brush [class*=fur-] {
  bottom: 0;
  height: 40%;
}
#SplashAnimation__wrp .netflixintro[data-letter=F] .helper-2 {
  width: 17.5%;
  height: 50%;
  left: 38%;
  top: -49px;
  transform: rotate(270deg);
  overflow: hidden;
}
#SplashAnimation__wrp .netflixintro[data-letter=F] .helper-2 .effect-brush {
  animation-name: brush-moving;
  animation-duration: 2s;
  animation-fill-mode: forwards;
  animation-delay: 0.7s;
}
#SplashAnimation__wrp .netflixintro[data-letter=F] .helper-3 {
  width: 17%;
  height: 39%;
  left: 33%;
  top: 29%;
  transform: rotate(-90deg);
  box-shadow: 0px 0px 35px -12px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  animation-name: fading-out;
  animation-duration: 2s;
  animation-fill-mode: forwards;
  animation-delay: 1s;
}
#SplashAnimation__wrp .netflixintro[data-letter=F] .helper-3 .effect-brush {
  animation-name: brush-moving;
  animation-duration: 2s;
  animation-fill-mode: forwards;
  animation-delay: 0.5s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] {
  position: absolute;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush {
  position: absolute;
  width: 100%;
  height: 300%;
  top: 0;
  overflow: hidden;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush::before {
  display: block;
  content: "";
  position: absolute;
  background-color: #e40913;
  width: 100%;
  height: 70%;
  box-shadow: 0px 0px 29px 24px #e40913;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush [class*=fur-] {
  display: block;
  position: absolute;
  bottom: 10%;
  height: 30%;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-1 {
  left: 0%;
  width: 3.8%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 15%, rgba(0, 0, 0, 0) 81%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-2 {
  left: 3.8%;
  width: 2.8%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 10%, rgba(0, 0, 0, 0) 62%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-3 {
  left: 6.6%;
  width: 4.8%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 37%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-4 {
  left: 11.4%;
  width: 4%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 23%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-5 {
  left: 15.4%;
  width: 4%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 15%, rgba(0, 0, 0, 0) 86%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-6 {
  left: 19.4%;
  width: 2.5%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 27%, rgba(0, 0, 0, 0) 89%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-7 {
  left: 21.9%;
  width: 4%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 20%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-8 {
  left: 25.9%;
  width: 2%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 30%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-9 {
  left: 27.9%;
  width: 4%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 35%, rgba(0, 0, 0, 0) 95%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-10 {
  left: 31.9%;
  width: 3.5%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 39%, rgba(0, 0, 0, 0) 95%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-11 {
  left: 35.4%;
  width: 2%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 34%, rgba(0, 0, 0, 0) 95%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-12 {
  left: 37.4%;
  width: 2.6%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 22%, rgba(0, 0, 0, 0) 95%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-13 {
  left: 40%;
  width: 6%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 47%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-14 {
  left: 46%;
  width: 2%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 36%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-15 {
  left: 48%;
  width: 5.5%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 29%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-16 {
  left: 53.5%;
  width: 3%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 39%, rgba(0, 0, 0, 0) 95%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-17 {
  left: 56.5%;
  width: 4.1%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 45%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-18 {
  left: 60.6%;
  width: 2.4%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 34%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-19 {
  left: 63%;
  width: 4%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 47%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-20 {
  left: 67%;
  width: 1.5%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 27%, rgba(0, 0, 0, 0) 95%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-21 {
  left: 68.5%;
  width: 2.8%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 37%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-22 {
  left: 71.3%;
  width: 2.3%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 9%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-23 {
  left: 73.6%;
  width: 2.2%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 28%, rgba(0, 0, 0, 0) 92%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-24 {
  left: 75.8%;
  width: 1%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 37%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-25 {
  left: 76.8%;
  width: 2.1%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 28%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-26 {
  left: 78.9%;
  width: 4.1%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 34%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-27 {
  left: 83%;
  width: 2.5%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 21%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-28 {
  left: 85.5%;
  width: 4.5%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 39%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-29 {
  left: 90%;
  width: 2.8%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 30%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-30 {
  left: 92.8%;
  width: 3.5%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 19%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-brush .fur-31 {
  left: 96.3%;
  width: 3.7%;
  background: linear-gradient(to bottom, #e40913 0%, #e40913 37%, rgba(0, 0, 0, 0) 100%);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  animation-name: showing-lumieres;
  animation-duration: 2s;
  animation-delay: 1.6s;
  animation-fill-mode: forwards;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres [class*=lamp-] {
  position: absolute;
  display: block;
  height: 100%;
  box-shadow: 0px 0px 10px 0px rgba(228, 9, 19, 0.75);
  background: var(--color);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres [class*=lamp-]::before {
  position: absolute;
  content: " ";
  display: block;
  width: 100%;
  height: 100%;
  background: var(--color);
  box-shadow: 0px 0px 10px 0px rgba(228, 9, 19, 0.75);
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-1 {
  --color: #ff0100;
  z-index: 6;
  left: 0.7%;
  width: 1%;
  animation-delay: 1.67s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-1::before {
  left: 34%;
  animation-delay: 0.25s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-2 {
  --color: #ffde01;
  left: 2.2%;
  width: 1.4%;
  animation-delay: 1.18s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-2::before {
  left: 63%;
  animation-delay: 0.87s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-3 {
  --color: #ff00cc;
  left: 5.8%;
  width: 2.1%;
  animation-delay: 1.83s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-3::before {
  left: 3%;
  animation-delay: 1.01s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-4 {
  --color: #04fd8f;
  left: 10.1%;
  width: 2%;
  animation-delay: 0.15s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-4::before {
  left: 115%;
  animation-delay: 1.42s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-5 {
  --color: #ff0100;
  left: 12.9%;
  width: 1.4%;
  animation-delay: 0.6s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-5::before {
  left: 25%;
  animation-delay: 1.98s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-6 {
  --color: #ff9600;
  left: 15.3%;
  width: 2.8%;
  animation-delay: 0.88s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-6::before {
  left: 56%;
  animation-delay: 1.3s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-7 {
  --color: #0084ff;
  left: 21.2%;
  width: 2.5%;
  animation-delay: 1.32s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-7::before {
  left: 91%;
  animation-delay: 1.25s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-8 {
  --color: #f84006;
  left: 25%;
  width: 2.5%;
  animation-delay: 1.6s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-8::before {
  left: 16%;
  animation-delay: 1.79s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-9 {
  --color: #ffc601;
  left: 30.5%;
  width: 3%;
  animation-delay: 0.19s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-9::before {
  left: 55%;
  animation-delay: 1.47s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-10 {
  --color: #ff4800;
  left: 36.3%;
  width: 3%;
  animation-delay: 0.72s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-10::before {
  left: 149%;
  animation-delay: 1.87s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-11 {
  --color: #fd0100;
  left: 41%;
  width: 2.2%;
  animation-delay: 1.49s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-11::before {
  left: 158%;
  animation-delay: 0.54s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-12 {
  --color: #01ffff;
  left: 44.2%;
  width: 2.6%;
  animation-delay: 0.27s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-12::before {
  left: 35%;
  animation-delay: 1.5s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-13 {
  --color: #ffc601;
  left: 51.7%;
  width: 0.5%;
  animation-delay: 1.5s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-13::before {
  left: 152%;
  animation-delay: 0.05s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-14 {
  --color: #ffc601;
  left: 52.1%;
  width: 1.8%;
  animation-delay: 0.16s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-14::before {
  left: 197%;
  animation-delay: 0.57s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-15 {
  --color: #0078fe;
  left: 53.8%;
  width: 2.3%;
  animation-delay: 0.46s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-15::before {
  left: 78%;
  animation-delay: 0.61s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-16 {
  --color: #0080ff;
  left: 57.2%;
  width: 2%;
  animation-delay: 1.32s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-16::before {
  left: 29%;
  animation-delay: 0.59s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-17 {
  --color: #ffae01;
  left: 62.3%;
  width: 2.9%;
  animation-delay: 1.78s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-17::before {
  left: 116%;
  animation-delay: 1.46s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-18 {
  --color: #ff00bf;
  left: 65.8%;
  width: 1.7%;
  animation-delay: 0.79s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-18::before {
  left: 132%;
  animation-delay: 1.86s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-19 {
  --color: #a601f4;
  left: 72.8%;
  width: 0.8%;
  animation-delay: 0.71s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-19::before {
  left: 198%;
  animation-delay: 0.43s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-20 {
  --color: #f30b34;
  left: 74.3%;
  width: 2%;
  animation-delay: 0.77s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-20::before {
  left: 54%;
  animation-delay: 1.03s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-21 {
  --color: #ff00bf;
  left: 79.8%;
  width: 2%;
  animation-delay: 1.01s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-21::before {
  left: 179%;
  animation-delay: 0.37s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-22 {
  --color: #04fd8f;
  left: 78.2%;
  width: 2%;
  animation-delay: 1.38s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-22::before {
  left: 70%;
  animation-delay: 1.51s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-23 {
  --color: #01ffff;
  left: 78.5%;
  width: 2%;
  animation-delay: 1.01s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-23::before {
  left: 181%;
  animation-delay: 1.57s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-24 {
  --color: #a201ff;
  left: 85.3%;
  width: 1.1%;
  animation-delay: 1.45s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-24::before {
  left: 126%;
  animation-delay: 1.97s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-25 {
  --color: #ec0014;
  left: 86.9%;
  width: 1.1%;
  animation-delay: 0.25s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-25::before {
  left: 25%;
  animation-delay: 1.89s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-26 {
  --color: #0078fe;
  left: 88.8%;
  width: 2%;
  animation-delay: 1.6s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-26::before {
  left: 51%;
  animation-delay: 1.59s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-27 {
  --color: #ff0036;
  left: 92.4%;
  width: 2.4%;
  animation-delay: 0.16s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-27::before {
  left: 94%;
  animation-delay: 0.3s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-28 {
  --color: #06f98c;
  left: 96.2%;
  width: 2.1%;
  animation-delay: 1.38s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-28::before {
  left: 129%;
  animation-delay: 0.14s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-1,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-3,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-5,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-7,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-9,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-11,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-13,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-15,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-17,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-19,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-21,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-23,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-25,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-27 {
  animation-name: lumieres-moving-left;
  animation-duration: 5s;
  animation-fill-mode: forwards;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-1::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-3::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-5::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-7::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-9::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-11::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-13::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-15::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-17::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-19::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-21::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-23::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-25::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-27::before {
  animation-name: lumieres-moving-left;
  animation-duration: 5.5s;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-2,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-4,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-6,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-8,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-10,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-12,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-14,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-16,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-18,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-20,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-22,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-24,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-26,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-28 {
  animation-name: lumieres-moving-right;
  animation-duration: 5s;
  animation-fill-mode: forwards;
}
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-2::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-4::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-6::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-8::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-10::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-12::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-14::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-16::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-18::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-20::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-22::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-24::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-26::before,
#SplashAnimation__wrp .netflixintro [class*=helper-] .effect-lumieres .lamp-28::before {
  animation-name: lumieres-moving-right;
  animation-duration: 5.5s;
}

@keyframes brush-moving {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100%);
  }
}
@keyframes fading-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes lumieres-moving-right {
  0% {
    transform: translate(0);
  }
  40% {
    transform: translate(-10px) scaleX(1);
  }
  50% {
    transform: translate(-60px);
  }
  100% {
    transform: translate(-120px) scaleX(3);
  }
}
@keyframes lumieres-moving-left {
  0% {
    transform: translate(0);
  }
  40% {
    transform: translate(10px) scaleX(1);
  }
  50% {
    transform: translate(60px);
  }
  100% {
    transform: translate(120px) scaleX(3);
  }
}
@keyframes zoom-in {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(15);
  }
}
@keyframes showing-lumieres {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fading-lumieres-box {
  0% {
    background-color: rgba(228, 9, 19, 0.5);
  }
  100% {
    background-color: rgba(228, 9, 19, 0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SplashAnimation/splashAnimation.scss","webpack://./src/scss/_variables.scss"],"names":[],"mappings":"AAGA;EACC,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,yBCdY;EDeZ,gBAAA;EACA,YAAA;AAFD;AAIC;EACC,cAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,wBAAA;EACA,kCAAA;EACA,6BAAA;EACA,uBAAA;EACA,8BAAA;AAFF;AAIE;EACC,WAAA;EACA,kBAAA;EACA,cAAA;EACA,yBCpCU;EDqCV,WAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,6BAAA;EACA,uBAAA;EACA,8BAAA;AAFH;AAKE;EACC,4BAAA;AAHH;AAKG;EACC,YAAA;EACA,YAAA;EACA,uCAAA;EACA,SAAA;EACA,MAAA;EACA,yBAAA;EACA,mCAAA;EACA,sBAAA;EACA,qBAAA;EACA,6BAAA;AAHJ;AAKI;EACC,4BAAA;EACA,wBAAA;EACA,6BAAA;EACA,qBAAA;AAHL;AAKK;EACC,SAAA;EACA,WAAA;AAHN;AAQG;EACC,YAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,gBAAA;AANJ;AAQI;EACC,4BAAA;EACA,sBAAA;EACA,6BAAA;EACA,qBAAA;AANL;AAUG;EACC,UAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,yBAAA;EACA,iDAAA;EACA,gBAAA;EACA,0BAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;AARJ;AAUI;EACC,4BAAA;EACA,sBAAA;EACA,6BAAA;EACA,qBAAA;AARL;AAaE;EACC,kBAAA;AAXH;AAaG;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,gBAAA;AAXJ;AAaI;EACC,cAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAhIQ;EAiIR,WAAA;EACA,WAAA;EACA,qCAAA;AAXL;AAcI;EACC,cAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;AAZL;AAeI;EACC,QAAA;EACA,WAAA;EACA,4GAAA;AAbL;AAeI;EACC,UAAA;EACA,WAAA;EACA,4GAAA;AAbL;AAeI;EACC,UAAA;EACA,WAAA;EACA,sFAAA;AAbL;AAeI;EACC,WAAA;EACA,SAAA;EACA,sFAAA;AAbL;AAeI;EACC,WAAA;EACA,SAAA;EACA,4GAAA;AAbL;AAeI;EACC,WAAA;EACA,WAAA;EACA,4GAAA;AAbL;AAeI;EACC,WAAA;EACA,SAAA;EACA,sFAAA;AAbL;AAeI;EACC,WAAA;EACA,SAAA;EACA,sFAAA;AAbL;AAeI;EACC,WAAA;EACA,SAAA;EACA,4GAAA;AAbL;AAeI;EACC,WAAA;EACA,WAAA;EACA,4GAAA;AAbL;AAeI;EACC,WAAA;EACA,SAAA;EACA,4GAAA;AAbL;AAeI;EACC,WAAA;EACA,WAAA;EACA,4GAAA;AAbL;AAeI;EACC,SAAA;EACA,SAAA;EACA,sFAAA;AAbL;AAeI;EACC,SAAA;EACA,SAAA;EACA,sFAAA;AAbL;AAeI;EACC,SAAA;EACA,WAAA;EACA,sFAAA;AAbL;AAeI;EACC,WAAA;EACA,SAAA;EACA,4GAAA;AAbL;AAeI;EACC,WAAA;EACA,WAAA;EACA,sFAAA;AAbL;AAeI;EACC,WAAA;EACA,WAAA;EACA,sFAAA;AAbL;AAeI;EACC,SAAA;EACA,SAAA;EACA,sFAAA;AAbL;AAeI;EACC,SAAA;EACA,WAAA;EACA,4GAAA;AAbL;AAeI;EACC,WAAA;EACA,WAAA;EACA,sFAAA;AAbL;AAeI;EACC,WAAA;EACA,WAAA;EACA,qFAAA;AAbL;AAeI;EACC,WAAA;EACA,WAAA;EACA,4GAAA;AAbL;AAeI;EACC,WAAA;EACA,SAAA;EACA,sFAAA;AAbL;AAeI;EACC,WAAA;EACA,WAAA;EACA,sFAAA;AAbL;AAeI;EACC,WAAA;EACA,WAAA;EACA,sFAAA;AAbL;AAeI;EACC,SAAA;EACA,WAAA;EACA,sFAAA;AAbL;AAeI;EACC,WAAA;EACA,WAAA;EACA,sFAAA;AAbL;AAeI;EACC,SAAA;EACA,WAAA;EACA,sFAAA;AAbL;AAeI;EACC,WAAA;EACA,WAAA;EACA,sFAAA;AAbL;AAeI;EACC,WAAA;EACA,WAAA;EACA,sFAAA;AAbL;AAiBG;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gCAAA;EACA,sBAAA;EACA,qBAAA;EACA,6BAAA;AAfJ;AAiBI;EACC,kBAAA;EACA,cAAA;EACA,YAAA;EACA,mDAAA;EACA,wBAAA;AAfL;AAiBK;EACC,kBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,mDAAA;AAfN;AAmBI;EACC,gBAAA;EACe,UAAA;EACf,UAAA;EACA,SAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,SAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,SAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,QAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,SAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,UAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;AAjBL;AAkBK;EACC,SAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,SAAA;EACA,qBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,SAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;AAjBL;AAkBK;EACC,SAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,SAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,SAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,SAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,UAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,SAAA;EACA,WAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,UAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,SAAA;EACA,qBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;AAjBL;AAkBK;EACC,UAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,UAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,SAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,SAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,SAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,UAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,UAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,UAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,SAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,SAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,SAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,UAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,SAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,SAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,SAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,UAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,UAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,SAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,SAAA;EACA,qBAAA;AAjBL;AAkBK;EACC,SAAA;EACA,sBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,SAAA;EACA,qBAAA;AAhBN;AAmBI;EACC,gBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;AAjBL;AAkBK;EACC,UAAA;EACA,sBAAA;AAhBN;AAoBI;;;;;;;;;;;;;;EAcC,oCAAA;EACA,sBAAA;EACA,6BAAA;AAlBL;AAmBK;;;;;;;;;;;;;;EACC,oCAAA;EACA,wBAAA;AAJN;AAQI;;;;;;;;;;;;;;EAcC,qCAAA;EACA,sBAAA;EACA,6BAAA;AANL;AAOK;;;;;;;;;;;;;;EACC,qCAAA;EACA,wBAAA;AAQN;;AAAA;EACC;IACC,wBAAA;EAGA;EADD;IACC,4BAAA;EAGA;AACF;AAAA;EACC;IACC,UAAA;EAEA;EAAD;IACC,UAAA;EAEA;AACF;AACA;EACC;IACC,uBAAA;EACA;EACD;IACC,qCAAA;EACA;EACD;IACC,2BAAA;EACA;EACD;IACC,sCAAA;EACA;AACF;AAEA;EACC;IACC,uBAAA;EAAA;EAED;IACC,oCAAA;EAAA;EAED;IACC,0BAAA;EAAA;EAED;IACC,qCAAA;EAAA;AACF;AAGA;EACC;IACC,mBAAA;EADA;EAGD;IACC,oBAAA;EADA;AACF;AAIA;EACC;IACC,UAAA;EAFA;EAID;IACC,UAAA;EAFA;AACF;AAKA;EACC;IACC,uCAAA;EAHA;EAKD;IACC,qCAAA;EAHA;AACF","sourcesContent":["@import \"../../scss/variables\";\n$custom-red: #e40913;\n\n#SplashAnimation__wrp {\n\tdisplay: flex;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 100%;\n\theight: 100%;\n\tmargin: 0;\n\tpadding: 0;\n\tbackground-color: $pure-black;\n\toverflow: hidden;\n\tz-index: 800;\n\n\t.netflixintro {\n\t\tdisplay: block;\n\t\tposition: relative;\n\t\twidth: 300px;\n\t\theight: 300px;\n\t\toverflow: hidden;\n\t\tanimation-name: zoom-in;\n\t\tanimation-delay: .5s;\n\t\tanimation-duration: 3.5s;\n\t\tanimation-timing-function: ease-in;\n\t\tanimation-fill-mode: forwards;\n\t\tbackground-size: 4000px;\n\t\tbackground-position: -1950px 0;\n\n\t\t&::before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tdisplay: block;\n\t\t\tbackground-color: $pure-black;\n\t\t\twidth: 150%;\n\t\t\theight: 30%;\n\t\t\tleft: -25%;\n\t\t\tbottom: -27%;\n\t\t\tborder-radius: 50%;\n\t\t\tz-index: 5;\n\t\t\ttransform-origin: left center;\n\t\t\tbackground-size: 4000px;\n\t\t\tbackground-position: -1950px 0;\n        }\n\n\t\t&[data-letter=\"F\"] {\n\t\t\ttransform-origin: 30% center;\n\n\t\t\t.helper-1 {\n\t\t\t\twidth: 19.5%;\n\t\t\t\theight: 100%;\n\t\t\t\tbackground-color: rgba($custom-red, .5);\n\t\t\t\tleft: 22%;\n\t\t\t\ttop: 0;\n\t\t\t\ttransform: rotate(180deg);\n\t\t\t\tanimation-name: fading-lumieres-box;\n\t\t\t\tanimation-duration: 2s;\n\t\t\t\tanimation-delay: .6s;\n\t\t\t\tanimation-fill-mode: forwards;\n\n\t\t\t\t.effect-brush {\n\t\t\t\t\tanimation-name: brush-moving;\n\t\t\t\t\tanimation-duration: 2.5s;\n\t\t\t\t\tanimation-fill-mode: forwards;\n\t\t\t\t\tanimation-delay: 1.2s;\n\n\t\t\t\t\t[class*=\"fur-\"] {\n\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\theight: 40%;\n                    }\n                }\n            }\n\n\t\t\t.helper-2 {\n\t\t\t\twidth: 17.5%;\n\t\t\t\theight: 50%;\n\t\t\t\tleft: 38%;\n\t\t\t\ttop: -49px;\n\t\t\t\ttransform: rotate(270deg);\n\t\t\t\toverflow: hidden;\n\n\t\t\t\t.effect-brush {\n\t\t\t\t\tanimation-name: brush-moving;\n\t\t\t\t\tanimation-duration: 2s;\n\t\t\t\t\tanimation-fill-mode: forwards;\n\t\t\t\t\tanimation-delay: .7s;\n                }\n            }\n\n\t\t\t.helper-3 {\n\t\t\t\twidth: 17%;\n\t\t\t\theight: 39%;\n\t\t\t\tleft: 33%;\n\t\t\t\ttop: 29%;\n\t\t\t\ttransform: rotate(-90deg);\n\t\t\t\tbox-shadow: 0px 0px 35px -12px rgba(0, 0, 0, 0.4);\n\t\t\t\toverflow: hidden;\n\t\t\t\tanimation-name: fading-out;\n\t\t\t\tanimation-duration: 2s;\n\t\t\t\tanimation-fill-mode: forwards;\n\t\t\t\tanimation-delay: 1s;\n\n\t\t\t\t.effect-brush {\n\t\t\t\t\tanimation-name: brush-moving;\n\t\t\t\t\tanimation-duration: 2s;\n\t\t\t\t\tanimation-fill-mode: forwards;\n\t\t\t\t\tanimation-delay: .5s;\n                }\n            }\n        }\n\n\t\t[class*=\"helper-\"] {\n\t\t\tposition: absolute;\n\n\t\t\t.effect-brush {\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 300%;\n\t\t\t\ttop: 0;\n\t\t\t\toverflow: hidden;\n\n\t\t\t\t&::before {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tbackground-color: $custom-red;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 70%;\n\t\t\t\t\tbox-shadow: 0px 0px 29px 24px $custom-red;\n                }\n\n\t\t\t\t[class*=\"fur-\"] {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tbottom: 10%;\n\t\t\t\t\theight: 30%;\n                }\n\n\t\t\t\t.fur-1 {\n\t\t\t\t\tleft: 0%;\n\t\t\t\t\twidth: 3.8%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 15%, rgba(0, 0, 0, 0) 81%, rgba(0, 0, 0, 0) 100%);\n            }\n\t\t\t\t.fur-2 {\n\t\t\t\t\tleft: 3.8%;\n\t\t\t\t\twidth: 2.8%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 10%, rgba(0, 0, 0, 0) 62%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-3 {\n\t\t\t\t\tleft: 6.6%;\n\t\t\t\t\twidth: 4.8%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 37%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-4 {\n\t\t\t\t\tleft: 11.4%;\n\t\t\t\t\twidth: 4%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 23%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-5 {\n\t\t\t\t\tleft: 15.4%;\n\t\t\t\t\twidth: 4%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 15%, rgba(0, 0, 0, 0) 86%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-6 {\n\t\t\t\t\tleft: 19.4%;\n\t\t\t\t\twidth: 2.5%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 27%, rgba(0, 0, 0, 0) 89%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-7 {\n\t\t\t\t\tleft: 21.9%;\n\t\t\t\t\twidth: 4%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 20%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-8 {\n\t\t\t\t\tleft: 25.9%;\n\t\t\t\t\twidth: 2%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 30%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-9 {\n\t\t\t\t\tleft: 27.9%;\n\t\t\t\t\twidth: 4%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 35%, rgba(0, 0, 0, 0) 95%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-10 {\n\t\t\t\t\tleft: 31.9%;\n\t\t\t\t\twidth: 3.5%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 39%, rgba(0, 0, 0, 0) 95%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-11 {\n\t\t\t\t\tleft: 35.4%;\n\t\t\t\t\twidth: 2%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 34%, rgba(0, 0, 0, 0) 95%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-12 {\n\t\t\t\t\tleft: 37.4%;\n\t\t\t\t\twidth: 2.6%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 22%, rgba(0, 0, 0, 0) 95%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-13 {\n\t\t\t\t\tleft: 40%;\n\t\t\t\t\twidth: 6%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 47%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-14 {\n\t\t\t\t\tleft: 46%;\n\t\t\t\t\twidth: 2%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 36%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-15 {\n\t\t\t\t\tleft: 48%;\n\t\t\t\t\twidth: 5.5%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 29%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-16 {\n\t\t\t\t\tleft: 53.5%;\n\t\t\t\t\twidth: 3%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 39%, rgba(0, 0, 0, 0) 95%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-17 {\n\t\t\t\t\tleft: 56.5%;\n\t\t\t\t\twidth: 4.1%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 45%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-18 {\n\t\t\t\t\tleft: 60.6%;\n\t\t\t\t\twidth: 2.4%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 34%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-19 {\n\t\t\t\t\tleft: 63%;\n\t\t\t\t\twidth: 4%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 47%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-20 {\n\t\t\t\t\tleft: 67%;\n\t\t\t\t\twidth: 1.5%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 27%, rgba(0, 0, 0, 0) 95%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-21 {\n\t\t\t\t\tleft: 68.5%;\n\t\t\t\t\twidth: 2.8%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 37%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-22 {\n\t\t\t\t\tleft: 71.3%;\n\t\t\t\t\twidth: 2.3%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 9%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-23 {\n\t\t\t\t\tleft: 73.6%;\n\t\t\t\t\twidth: 2.2%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 28%, rgba(0, 0, 0, 0) 92%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-24 {\n\t\t\t\t\tleft: 75.8%;\n\t\t\t\t\twidth: 1%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 37%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-25 {\n\t\t\t\t\tleft: 76.8%;\n\t\t\t\t\twidth: 2.1%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 28%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-26 {\n\t\t\t\t\tleft: 78.9%;\n\t\t\t\t\twidth: 4.1%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 34%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-27 {\n\t\t\t\t\tleft: 83%;\n\t\t\t\t\twidth: 2.5%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 21%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-28 {\n\t\t\t\t\tleft: 85.5%;\n\t\t\t\t\twidth: 4.5%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 39%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-29 {\n\t\t\t\t\tleft: 90%;\n\t\t\t\t\twidth: 2.8%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 30%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-30 {\n\t\t\t\t\tleft: 92.8%;\n\t\t\t\t\twidth: 3.5%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 19%, rgba(0, 0, 0, 0) 100%);\n                }\n\t\t\t\t.fur-31 {\n\t\t\t\t\tleft: 96.3%;\n\t\t\t\t\twidth: 3.7%;\n\t\t\t\t\tbackground: linear-gradient(to bottom, $custom-red 0%, $custom-red 37%, rgba(0, 0, 0, 0) 100%);\n                }\n            }\n\n\t\t\t.effect-lumieres {\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\topacity: 0;\n\t\t\t\tanimation-name: showing-lumieres;\n\t\t\t\tanimation-duration: 2s;\n\t\t\t\tanimation-delay: 1.6s;\n\t\t\t\tanimation-fill-mode: forwards;\n\n\t\t\t\t[class*=\"lamp-\"] {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tbox-shadow: 0px 0px 10px 0px rgba($custom-red, 0.75);\n\t\t\t\t\tbackground: var(--color);\n\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tcontent: \" \";\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\tbackground: var(--color);\n\t\t\t\t\t\tbox-shadow: 0px 0px 10px 0px rgba($custom-red, 0.75);\n                    }\n                }\n\n\t\t\t\t.lamp-1 {\n\t\t\t\t\t--color: #ff0100;\n                    z-index: 6;\n\t\t\t\t\tleft: 0.7%;\n\t\t\t\t\twidth: 1%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-2 {\n\t\t\t\t\t--color: #ffde01;\n\t\t\t\t\tleft: 2.2%;\n\t\t\t\t\twidth: 1.4%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-3 {\n\t\t\t\t\t--color: #ff00cc;\n\t\t\t\t\tleft: 5.8%;\n\t\t\t\t\twidth: 2.1%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-4 {\n\t\t\t\t\t--color: #04fd8f;\n\t\t\t\t\tleft: 10.1%;\n\t\t\t\t\twidth: 2%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-5 {\n\t\t\t\t\t--color: #ff0100;\n\t\t\t\t\tleft: 12.9%;\n\t\t\t\t\twidth: 1.4%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-6 {\n\t\t\t\t\t--color: #ff9600;\n\t\t\t\t\tleft: 15.3%;\n\t\t\t\t\twidth: 2.8%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-7 {\n\t\t\t\t\t--color: #0084ff;\n\t\t\t\t\tleft: 21.2%;\n\t\t\t\t\twidth: 2.5%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-8 {\n\t\t\t\t\t--color: #f84006;\n\t\t\t\t\tleft: 25%;\n\t\t\t\t\twidth: 2.5%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-9 {\n\t\t\t\t\t--color: #ffc601;\n\t\t\t\t\tleft: 30.5%;\n\t\t\t\t\twidth: 3%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-10 {\n\t\t\t\t\t--color: #ff4800;\n\t\t\t\t\tleft: 36.3%;\n\t\t\t\t\twidth: 3%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-11 {\n\t\t\t\t\t--color: #fd0100;\n\t\t\t\t\tleft: 41%;\n\t\t\t\t\twidth: 2.2%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-12 {\n\t\t\t\t\t--color: #01ffff;\n\t\t\t\t\tleft: 44.2%;\n\t\t\t\t\twidth: 2.6%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-13 {\n\t\t\t\t\t--color: #ffc601;\n\t\t\t\t\tleft: 51.7%;\n\t\t\t\t\twidth: 0.5%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-14 {\n\t\t\t\t\t--color: #ffc601;\n\t\t\t\t\tleft: 52.1%;\n\t\t\t\t\twidth: 1.8%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-15 {\n\t\t\t\t\t--color: #0078fe;\n\t\t\t\t\tleft: 53.8%;\n\t\t\t\t\twidth: 2.3%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-16 {\n\t\t\t\t\t--color: #0080ff;\n\t\t\t\t\tleft: 57.2%;\n\t\t\t\t\twidth: 2%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-17 {\n\t\t\t\t\t--color: #ffae01;\n\t\t\t\t\tleft: 62.3%;\n\t\t\t\t\twidth: 2.9%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-18 {\n\t\t\t\t\t--color: #ff00bf;\n\t\t\t\t\tleft: 65.8%;\n\t\t\t\t\twidth: 1.7%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-19 {\n\t\t\t\t\t--color: #a601f4;\n\t\t\t\t\tleft: 72.8%;\n\t\t\t\t\twidth: 0.8%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-20 {\n\t\t\t\t\t--color: #f30b34;\n\t\t\t\t\tleft: 74.3%;\n\t\t\t\t\twidth: 2%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-21 {\n\t\t\t\t\t--color: #ff00bf;\n\t\t\t\t\tleft: 79.8%;\n\t\t\t\t\twidth: 2%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-22 {\n\t\t\t\t\t--color: #04fd8f;\n\t\t\t\t\tleft: 78.2%;\n\t\t\t\t\twidth: 2%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-23 {\n\t\t\t\t\t--color: #01ffff;\n\t\t\t\t\tleft: 78.5%;\n\t\t\t\t\twidth: 2%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-24 {\n\t\t\t\t\t--color: #a201ff;\n\t\t\t\t\tleft: 85.3%;\n\t\t\t\t\twidth: 1.1%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-25 {\n\t\t\t\t\t--color: #ec0014;\n\t\t\t\t\tleft: 86.9%;\n\t\t\t\t\twidth: 1.1%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-26 {\n\t\t\t\t\t--color: #0078fe;\n\t\t\t\t\tleft: 88.8%;\n\t\t\t\t\twidth: 2%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-27 {\n\t\t\t\t\t--color: #ff0036;\n\t\t\t\t\tleft: 92.4%;\n\t\t\t\t\twidth: 2.4%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\t\t\t\t.lamp-28 {\n\t\t\t\t\t--color: #06f98c;\n\t\t\t\t\tleft: 96.2%;\n\t\t\t\t\twidth: 2.1%;\n\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tleft: percentage((calc(random(200) / 100)));\n\t\t\t\t\t\tanimation-delay: (calc(random(200) / 100)) + s;\n                    }\n                  }\n\n\t\t\t\t.lamp-1,\n\t\t\t\t.lamp-3,\n\t\t\t\t.lamp-5,\n\t\t\t\t.lamp-7,\n\t\t\t\t.lamp-9,\n\t\t\t\t.lamp-11,\n\t\t\t\t.lamp-13,\n\t\t\t\t.lamp-15,\n\t\t\t\t.lamp-17,\n\t\t\t\t.lamp-19,\n\t\t\t\t.lamp-21,\n\t\t\t\t.lamp-23,\n\t\t\t\t.lamp-25,\n\t\t\t\t.lamp-27 {\n\t\t\t\t\tanimation-name: lumieres-moving-left;\n\t\t\t\t\tanimation-duration: 5s;\n\t\t\t\t\tanimation-fill-mode: forwards;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tanimation-name: lumieres-moving-left;\n\t\t\t\t\t\tanimation-duration: 5.5s;\n                    }\n                }\n\n\t\t\t\t.lamp-2,\n\t\t\t\t.lamp-4,\n\t\t\t\t.lamp-6,\n\t\t\t\t.lamp-8,\n\t\t\t\t.lamp-10,\n\t\t\t\t.lamp-12,\n\t\t\t\t.lamp-14,\n\t\t\t\t.lamp-16,\n\t\t\t\t.lamp-18,\n\t\t\t\t.lamp-20,\n\t\t\t\t.lamp-22,\n\t\t\t\t.lamp-24,\n\t\t\t\t.lamp-26,\n\t\t\t\t.lamp-28 {\n\t\t\t\t\tanimation-name: lumieres-moving-right;\n\t\t\t\t\tanimation-duration: 5s;\n\t\t\t\t\tanimation-fill-mode: forwards;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tanimation-name: lumieres-moving-right;\n\t\t\t\t\t\tanimation-duration: 5.5s;\n                    }\n                }\n            }\n        }\n    }\n}\n\n@keyframes brush-moving {\n\t0% {\n\t\ttransform: translateY(0);\n    }\n\t100% {\n\t\ttransform: translateY(-100%);\n    }\n}\n\n@keyframes fading-out {\n\t0% {\n\t\topacity: 1;\n    }\n\t100% {\n\t\topacity: 0;\n    }\n}\n\n@keyframes lumieres-moving-right {\n\t0% {\n\t\ttransform: translate(0);\n    }\n\t40% {\n\t\ttransform: translate(-10px) scaleX(1);\n    }\n\t50% {\n\t\ttransform: translate(-60px);\n    }\n\t100% {\n\t\ttransform: translate(-120px) scaleX(3);\n    }\n}\n\n@keyframes lumieres-moving-left {\n\t0% {\n\t\ttransform: translate(0);\n    }\n\t40% {\n\t\ttransform: translate(10px) scaleX(1);\n    }\n\t50% {\n\t\ttransform: translate(60px);\n    }\n\t100% {\n\t\ttransform: translate(120px) scaleX(3);\n    }\n}\n\n@keyframes zoom-in {\n\t0% {\n\t\ttransform: scale(1);\n    }\n\t100% {\n\t\ttransform: scale(15);\n    }\n}\n\n@keyframes showing-lumieres {\n\t0% {\n\t\topacity: 0;\n    }\n\t100% {\n\t\topacity: 1;\n    }\n}\n\n@keyframes fading-lumieres-box {\n\t0% {\n\t\tbackground-color: rgba($custom-red, .5);\n    }\n\t100% {\n\t\tbackground-color: rgba($custom-red, .0);\n    }\n}\n","$white: #f2f2f2;\n$pure-black: #030303;\n$light-black: #181818;\n$black: #141414;\n$red: #e50914;\n$grey: #101011;\n$blue-google: #1356c7;\n\n$main-font: 'Inter', sans-serif;\n$fakeflix-font: 'Bebas Neue', cursive;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
